import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addOption({ commit }, item) {
    return this.$axios.$post('admin/options/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removeOption({ commit }, item) {
    return this.$axios.$delete(`admin/options/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateOption({ commit }, item) {
    return this.$axios.$put(`admin/options/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchOptions({ commit }) {
    return this.$axios.$get('admin/options').then((response) => {
      commit('load', response.data)
    })
  },
}
